export default "__VITE_ASSET__b0fe3dcc__"